export default {"src":"/_next/static/media/Refresh.21981fa1.svg","height":16,"width":16};